var modules_783e1af8 = {"container":"ExpandCell_module_container__20e3a3d1","icon":"ExpandCell_module_icon__20e3a3d1"};
import "../../../assets/esm/components/Table/src/ExpandColumn~0IdIQ5u2.css";

export { modules_783e1af8 as default };
//# sourceMappingURL=ExpandCell.module.less.js.map
